module.exports = __webpack_public_path__ + "img/logo2.1b78f9c3.png";